import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import {SummaryServiceProvider} from '../../../../providers/wh/summary-service';
import { DatePipe } from '@angular/common';
import { ShipmentsPage } from '../../shipments/shipments';

@Component({
  selector: 'action-history',
  templateUrl: 'index.html',
  providers: [SummaryServiceProvider]
})
export class WhActionHistoryPage {
 header_data:any;

  d: any; r: string;
  div_:any;
  
  public start_time :string = '';
  public end_time :any = '';
  public avl_rules:any="";


pet:any;
dashboard_data:any="";
  public drivers_list: any;
  objectKeys = Object.keys;
  constructor(public navCtrl: NavController,public datepipe: DatePipe, public navParams: NavParams,public summaryService: SummaryServiceProvider,public loadingCtrl: LoadingController) {
    this.header_data={ismenu:true,ishome:false,title:"Action History",parentReloadData:d=>{this.load_dashboard_data(true)}};

    this.load_dashboard_data(true);

    this.div_=[];


  }

  load_dashboard_data(show_loader)
  {
    let q:any ='';

      if(this.start_time!=='')
      {
        q+='from='+this.datepipe.transform(this.start_time, 'yyyy-MM-dd');
      }

      if(this.start_time!=='')
      {
        q+='to='+this.datepipe.transform(this.end_time, 'yyyy-MM-dd');
      }

      if(this.avl_rules!=='')
      {
        q+='&rules='+this.avl_rules;
      }



 if(show_loader)
 {
  let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();

        this.summaryService.load_dashboard_actions_history_data(q)
        .then(data => {
          this.dashboard_data = data;
          //console.log(this.dashboard_data);
           this.pet = "0";
        });

      loader.dismiss();
    }
    else{
         this.summaryService.load_dashboard_actions_history_data(q)
        .then(data => {
          this.dashboard_data = data;
          //console.log(this.dashboard_data);
           this.pet = "0";
        });
    }

  }

  gotoSearch(awbs) {
    this.navCtrl.push(ShipmentsPage, {
      awbs_param: awbs
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/backoffice/overall/history/index.ts